import { useEffect, useState, useRef, type ReactNode } from 'react';
import { tenant } from '../tenant';
import { guideOn, loadGuide, onGuideChange, type TourId } from '../guide';

/** Tutor profile only: starts the screen's ARH Guide tour; a dot marks one not finished yet. */
export function GuideButton({ tour }: { tour: TourId }) {
  const [fresh, setFresh] = useState(false);
  useEffect(() => {
    const read = () => void loadGuide()?.then((g) => setFresh(!g.status(tour)));
    read();
    return onGuideChange(read);
  }, [tour]);
  return (
    <button className="btn arh-guide-launcher" data-new={fresh ? '' : undefined} aria-label="Show a short guide to this screen" onClick={() => void loadGuide()?.then((g) => g.start(tour))} data-testid="guide-button">
      Guide
    </button>
  );
}

export function Brand() {
  if(tenant.id==='tutor')return <a className="brand tutor-brand" href={tenant.homeUrl}>TUTOR<sub>by ARH</sub></a>;
  return (
    <span className="brand">
      <span className="mark" aria-hidden="true" />
      {tenant.brandName}
    </span>
  );
}

export function TopBar({ title, children }: { title?: string; children?: ReactNode }) {
  const [dark,setDark]=useState(document.documentElement.dataset.theme==='dark');
  const bar=useRef<HTMLElement>(null);
  useEffect(()=>{
    if(tenant.id!=='tutor'||!bar.current)return;
    const update=()=>document.documentElement.style.setProperty('--tutor-header-height',`${bar.current?.offsetHeight ?? 68}px`);
    const observer=new ResizeObserver(update);observer.observe(bar.current);update();return ()=>observer.disconnect();
  },[]);
  return (
    <>
      <div className="stripe" />
      <header className="bar" ref={bar}>
        <Brand />
        {title && (
          <>
            <span className="muted" aria-hidden="true">
              |
            </span>
            <strong>{title}</strong>
          </>
        )}
        <span className="spacer" />
        {guideOn&&/^\/w\//.test(location.pathname)&&<GuideButton tour="workspace" />}
        {tenant.id==='tutor'&&<><a className="btn ghost tutor-return" href={tenant.homeUrl}>Tutor workspace</a><button className="btn" aria-pressed={dark} onClick={()=>{const next=!dark;setDark(next);document.documentElement.dataset.theme=next?'dark':'light';try{localStorage.setItem('tutor-video-theme',next?'dark':'light');}catch{}}}>{dark?'Light mode':'Dark mode'}</button></>}
        {children}
      </header>
    </>
  );
}

export function Page({ title, bar, children }: { title?: string; bar?: ReactNode; children: ReactNode }) {
  return (
    <div className="page">
      <TopBar title={title}>{bar}</TopBar>
      <main className="center">{children}</main>
    </div>
  );
}
